import type { BaseHtmlProps, BasePropConversionOptions } from "../../../utilities/getHtmlPropsFromBaseProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";
import type { RTEBaseDefs } from "../RichTextEditorProps";

export type RTEBaseConvertOpts = BasePropConversionOptions;
export type RTEBaseConvertDefs = BaseHtmlProps;

export const getHtmlDefsFromBaseProps = (baseProps: RTEBaseDefs, options?: RTEBaseConvertOpts): RTEBaseConvertDefs =>
  getHtmlPropsFromBaseProps(baseProps, options);
